import React from 'react';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';
import English from '../lang/en.json';
import Thai from '../lang/th.json';

export const Context = React.createContext();

const local = navigator.language;

let lang;
if (local === 'en') {
	lang = English;
} else if (local === 'th') {
	lang = Thai;
} else {
	lang = English;
}

const Wrapper = props => {
	const { children } = props;

	return (
		<Context.Provider value={{ locale: local }}>
			<IntlProvider messages={lang} locale={local}>
				{children}
			</IntlProvider>
		</Context.Provider>
	);
};

Wrapper.propTypes = {
	children: PropTypes.any.isRequired
};

export default Wrapper;
